import { UNTITLED_ZAP_DEFAULT } from "./constants";

export const isUntitledZap = (title: string | null | undefined): boolean =>
  !title?.trim() || title.trim() === UNTITLED_ZAP_DEFAULT;

export const getZapDisplayTitle = (title: string | null | undefined): string =>
  isUntitledZap(title) ? UNTITLED_ZAP_DEFAULT : title || "";
